const USER_TOKEN_ID = "TEMPLATE_PANEL_TOKEN_ID"
const USER_REFRESH_TOKEN = "TEMPLATE_PANEL_REFRESH_TOKEN"

export function setUserToken(token) {
    localStorage.setItem(USER_TOKEN_ID, token)
}

export function getUserToken() {
    return localStorage.getItem(USER_TOKEN_ID)
}

export function removeUserToken() {
    localStorage.removeItem(USER_TOKEN_ID)
}

export function setUserRefreshToken(refreshToken) {
    localStorage.setItem(USER_REFRESH_TOKEN, refreshToken)
}

export function getUserRefreshToken() {
    return localStorage.getItem(USER_REFRESH_TOKEN)
}

export function removeUserRefreshToken() {
    localStorage.removeItem(USER_REFRESH_TOKEN)
}
